import api from '../config/api';
import { API_URLS } from '../config/urls';

export const contactService = {
    getContactDetails: async () => {
        const response = await api.get(API_URLS.CONTACT_DETAILS);
        return response.data;
    },
    sendContactMessage: async (data) => {
        const response = await api.post(API_URLS.CONTACT_MESSAGE, data);
        return response.data;
    },
};
